export default "/fonts/bauhs93-webfont.svg?9f3185d969b2b5b3d8fc43c417cfc499";